/**
 * Header strip for "Inform the chief of staff": how many changes are not yet
 * committed, the commit button, and when the last commit went out. Nothing
 * reaches the team until the owner commits.
 */
import type { CommitRef, PendingChanges } from "../../api/focus";
import { chiefOfStaffName } from "../../lib/focus";
import { formatRelative } from "../../lib/formatRelative";

export function CommitBar({
  pending,
  lastCommit,
  onOpen,
}: {
  pending: PendingChanges | undefined;
  lastCommit: CommitRef | null | undefined;
  onOpen: () => void;
}) {
  const count = pending?.count ?? 0;
  return (
    <div className="commit-bar">
      {count > 0 ? (
        <button
          type="button"
          className="pill pill--signal commit-bar-count"
          onClick={onOpen}
          title={pending?.affects_team ? "Includes changes the team should know about" : "Only you see these so far"}
        >
          {count} uncommitted {count === 1 ? "change" : "changes"}
        </button>
      ) : (
        <span className="pill pill--muted">All committed</span>
      )}
      <button type="button" className="btn btn-sm btn-main" disabled={count === 0} onClick={onOpen}>
        Inform {chiefOfStaffName(pending)}
      </button>
      {lastCommit?.created_at ? (
        <span className="commit-bar-last">last commit {formatRelative(lastCommit.created_at)}</span>
      ) : null}
    </div>
  );
}
